import { apiSpaceUrl } from "utils/urls";

import axios from "axios";

export const postBibliography = async (spaceUuid, { params, body }) => {
    const { data } = await axios.post(apiSpaceUrl("bibliography", spaceUuid), body, {
        params: params,
    });
    return data;
};

export const postReferenceAddFromSource = async (spaceUuid, { body }) => {
    const { data } = await axios.post(apiSpaceUrl("referenceAddFromSource", spaceUuid), body);
    return data;
};

export const postBulkBibliography = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("bibliography", spaceUuid) + "/bulk-create", body);
    return data;
};

export const patchBibliography = async (spaceUuid, body) => {
    let headers = {};
    if (body.file) {
        headers = {
            "Content-Type": "multipart/form-data",
        };
    }
    const { data } = await axios.patch(apiSpaceUrl("bibliography", spaceUuid) + "/" + body.id, body, {
        headers: headers,
    });
    return data;
};

export const putBibJson = async (spaceUuid, body) => {
    const { data } = await axios.put(apiSpaceUrl("bibliography", spaceUuid) + "/" + body.id + "/bib-json", body);
    return data;
};

export const getBibliographyList = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("bibliography", spaceUuid), { params: params });
    return data;
};

export const getBibliography = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("bibliography", spaceUuid) + "/no/" + params.reference_no);
    return data;
};

export const deleteBibliography = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("bibliography", spaceUuid) + "/bulk_delete", {
        data: body,
    });

    return data;
};

export const deleteReferencePdfFile = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("bibliography", spaceUuid) + "/file/reference", {
        data: body,
    });

    return data;
};

export const getJsonToBib = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("bibliography", spaceUuid) + "/json-to-bib", body);
    return data;
};

export const restartReferenceFileIndexing = async (spaceUuid, reference_file_id) => {
    const { data } = axios.put(apiSpaceUrl("referenceFile", spaceUuid) + "/indexing-restart", {
        reference_file_id,
    });

    return data;
};
